import * as React from "react";
// UI frameworks
import { Steps } from "antd";
// Shared components
import FirstStep from "./components/FirstStep";
import SecondStep from "./components/SecondStep";
import ThirdStep from "./components/ThirdStep";
// Local components
import Maybe from "components/Maybe";
// Styles
import styles from "./index.module.scss";

interface IState {
	unit?: number;
	amount?: number;
	current: number;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IAction extends Partial<IState> {}

const initialState = () => ({ unit: 0, amount: 0, current: 0 } as IState);

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

interface IContextProps {
	state: IState;
	dispatch: any;
}

const SellContext = React.createContext({ state: initialState(), dispatch: () => {} } as IContextProps);
const { Step } = Steps;

const Sell: React.FC = () => {
	const [store, dispatch] = React.useReducer(reducer, initialState());

	return (
		<div className="container">
			<div className={styles["main"]}>
				<div className={styles["main__steps"]}>
					<Steps current={store.current}>
						<Step />
						<Step />
						<Step />
					</Steps>
				</div>
				<SellContext.Provider value={{ state: store, dispatch }}>
					<div className={styles["main__content"]}>
						<Maybe condition={store.current === 0}>
							<FirstStep />
						</Maybe>
						<Maybe condition={store.current === 1}>
							<SecondStep />
						</Maybe>
						<Maybe condition={store.current === 2}>
							<ThirdStep />
						</Maybe>
					</div>
				</SellContext.Provider>
			</div>
		</div>
	);
};

export const useSell = () => React.useContext(SellContext);
export default Sell;
